import { ReactElement } from 'react';
import GiftCardTable from '../GiftCardTable/GiftCardTable';

import { TGiftCard } from '../Home.page';

type TExpiredCardTable = (props: { isLoading: boolean; giftCards: Array<TGiftCard> }) => ReactElement;

/* ==================================== Main Component ==================================== */
const ExpiredGiftCardTable: TExpiredCardTable = ({ isLoading, giftCards }) => {
  return <GiftCardTable isLoading={isLoading} giftCards={giftCards} hasAction={false} />;
};

export default ExpiredGiftCardTable;
